/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_DescriptionInputs */

const en_directory_tools_description = /** @type {(inputs: Directory_Tools_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the Seek AI tools that are live today. Every destination below performs a real task in the current product.`)
};

const zh_directory_tools_description = /** @type {(inputs: Directory_Tools_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Seek AI 当前已经上线的工具。下面每个入口都能在现有产品中完成真实任务。`)
};

/**
* | output |
* | --- |
* | "Use the Seek AI tools that are live today. Every destination below performs a real task in the current product." |
*
* @param {Directory_Tools_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_description = /** @type {((inputs?: Directory_Tools_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_description(inputs)
	return zh_directory_tools_description(inputs)
});
export { directory_tools_description as "directory.tools.description" }